/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as PlayState from './state.defs.js'

const $nsid = 'at.tastetest.play.get'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  league: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<View>((() => view) as any),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type View = {
  $type?: 'at.tastetest.play.get#view'
  exists: boolean
  theme?: string
  phase?: string
  submissionEndsAt?: number
  votingEndsAt?: number
  upvotes?: number
  eligible?: boolean
  hasVoted?: boolean
  picks: PickView[]
  roundNumber?: number
  history?: CompletedView[]
  standings?: Standing[]
  description?: string
  startsAt?: number
  plannedRounds?: PlayState.PlannedRound[]
  openMembership?: boolean
}

export type { View }

const view = /*#__PURE__*/ l.typedObject<View>(
  $nsid,
  'view',
  /*#__PURE__*/ l.object({
    exists: /*#__PURE__*/ l.boolean(),
    theme: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    phase: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    submissionEndsAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 9007199254740991 }),
    ),
    votingEndsAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 9007199254740991 }),
    ),
    upvotes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
    ),
    eligible: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    hasVoted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    picks: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<PickView>((() => pickView) as any),
      { maxLength: 20 },
    ),
    roundNumber: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    ),
    history: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<CompletedView>((() => completedView) as any),
        { maxLength: 19 },
      ),
    ),
    standings: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<Standing>((() => standing) as any),
        { maxLength: 20 },
      ),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1000 }),
    ),
    startsAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 9007199254740991 }),
    ),
    plannedRounds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<PlayState.PlannedRound>(
          (() => PlayState.plannedRound) as any,
        ),
        { maxLength: 19 },
      ),
    ),
    openMembership: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { view }

type PickView = {
  $type?: 'at.tastetest.play.get#pickView'
  token: string
  url: string
  title: string
  isOwn: boolean
  owner?: l.DidString
  score?: number
  rank?: number
  penalized?: boolean
  provider?: string
  availability?: 'available' | 'unavailable' | 'changed' | 'unknown'
}

export type { PickView }

const pickView = /*#__PURE__*/ l.typedObject<PickView>(
  $nsid,
  'pickView',
  /*#__PURE__*/ l.object({
    token: /*#__PURE__*/ l.string(),
    url: /*#__PURE__*/ l.string(),
    title: /*#__PURE__*/ l.string(),
    isOwn: /*#__PURE__*/ l.boolean(),
    owner: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
    score: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: -10000, maximum: 10000 }),
    ),
    rank: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    ),
    penalized: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    provider: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    availability: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.enum(['available', 'unavailable', 'changed', 'unknown']),
    ),
  }),
)

export { pickView }

type CompletedView = {
  $type?: 'at.tastetest.play.get#completedView'
  roundNumber: number
  theme: string
  picks: PickView[]
  description?: string
}

export type { CompletedView }

const completedView = /*#__PURE__*/ l.typedObject<CompletedView>(
  $nsid,
  'completedView',
  /*#__PURE__*/ l.object({
    roundNumber: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    theme: /*#__PURE__*/ l.string(),
    picks: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<PickView>((() => pickView) as any),
      { maxLength: 20 },
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1000 }),
    ),
  }),
)

export { completedView }

type Standing = {
  $type?: 'at.tastetest.play.get#standing'
  owner: l.DidString
  score: number
  rank: number
  roundsPlayed: number
}

export type { Standing }

const standing = /*#__PURE__*/ l.typedObject<Standing>(
  $nsid,
  'standing',
  /*#__PURE__*/ l.object({
    owner: /*#__PURE__*/ l.string({ format: 'did' }),
    score: /*#__PURE__*/ l.integer({ minimum: -200000, maximum: 200000 }),
    rank: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    roundsPlayed: /*#__PURE__*/ l.integer({ minimum: 0, maximum: 20 }),
  }),
)

export { standing }
